<template>
	<v-flex>
		<v-currency-field
			:error-messages="$props.error"
			:label="$props.label"
			:mask="$props.mask"
			:placeholder="' '"
			:type="$props.type"
			class="ml-2 mr-2"
			v-bind="currency_config"
			v-if="!isSimple"
			v-model="inputValue"></v-currency-field>

		<v-currency-field
			:mask="$props.mask"
			:placeholder="$props.placeholder" :type="$props.type"
			class="ml-0 mr-0 simple"
			v-bind="currency_config"
			v-if="isSimple"
			v-model="inputValue"></v-currency-field>
	</v-flex>
</template>

<script>
	export default {
		name: "QuantityField",
		props: ['simple', 'value', 'error', 'placeholder', 'label', 'type', 'mask'],
		data() {
			return {
				inputValue: this.$props.value,
				currency_config: {
					locale: 'de',
					prefix: '',
					suffix: '',
					precision: 2,
					'auto-decimal-mode': false,
					allowBlank: false,
					min: Number.MIN_SAFE_INTEGER,
					max: Number.MAX_SAFE_INTEGER
				}
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}

	>>> .simple .v-text-field__details {
		display: none;
	}

	>>> .simple .v-input__slot {
		padding: 0px;
		margin: 0px;
	}
</style>
